import { render, staticRenderFns } from "./BasicMenu.vue?vue&type=template&id=4225e3a7&lang=pug&"
import script from "./BasicMenu.vue?vue&type=script&lang=js&"
export * from "./BasicMenu.vue?vue&type=script&lang=js&"
import style0 from "./BasicMenu.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports